import { useQuery } from '@apollo/client';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Navigation from '../common/navigation/NavigationContainer';
import NavBannerDesktop from './navigation/common/NavBannerDesktop';
import { GET_TOTAL_CART_PRODUCTS } from './SharedQueries';
import useSale from '@/hooks/useSale';

const NavigationCheckout = lazy(() => import('./NavigationCheckout'));
const AdminMenu = lazy(() => import('./AdminMenu'));

function NavigationWrapper(props) {
  const location = useLocation();
  const isAdminView = location.pathname.startsWith('/admin');
  const isLeaveReviews =
    location.pathname.startsWith('/reviews') && location.pathname.length > 9;
  const isCheckoutView =
    location.pathname === '/cart' || location.pathname.startsWith('/checkout');

  const isCheckoutConfirmation = location.pathname.startsWith(
    '/checkout/confirmation/'
  );

  const { isSale } = useSale();

  useQuery(GET_TOTAL_CART_PRODUCTS, {
    skip: !props.isAuthenticated
  });

  if (isCheckoutView && !isCheckoutConfirmation) {
    return (
      <Suspense fallback={<Navigation />}>
        <div className="nav-wrapper">
          {isSale && (
            <NavBannerDesktop className="nav-banner-desktop hide-on-mobile" />
          )}
          <NavigationCheckout
            user={props.user}
            isAuthenticated={props.isAuthenticated}
          />
        </div>
      </Suspense>
    );
  }

  if (isLeaveReviews) {
    return '';
  }

  if (isAdminView) {
    return (
      <Suspense fallback={<Navigation />}>
        <AdminMenu />
      </Suspense>
    );
  }

  return <Navigation />;
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
    total: state.LocalCart.total
  };
};

const mapDispatchToProps = dispatch => ({});

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default React.memo(NavigationWrapper);
